import { t } from "i18next";
import { List } from "immutable";
import { PersonalAccessTokenModel } from "models/PersonalAccessTokenModel";
import { UserPersonalAccessTokenModel } from "models/UserPersonalAccessTokenModel";
import { apiReq } from "utils/api/apiReq";

type TCreatePersonalAccessToken = {
  duration: null | number;
  name: string;
};

export async function generateCLIAccessToken(port: number, secured: null | string) {
  const query = new URLSearchParams({ port: String(port) });
  if (secured) {
    query.set("secured", secured);
  }

  try {
    return await apiReq(
      "POST",
      `/v1/userAccessTokens/cli?${query.toString()}`,
      undefined,
      {
        expectJson: false,
        expectJsonOnError: true,
        redirect: "follow",
      },
    );
  } catch (err) {
    if (err instanceof Error && err.message === "Failed to fetch") {
      throw new Error(t("pages.cliTokenGeneration.serverNotResponding", { port }));
    }
    throw err;
  }
}

export async function getPersonalAccessTokens() {
  const { data } = await apiReq("GET", "/v1/userAccessTokens");

  return List<PersonalAccessTokenModel>(data.map(PersonalAccessTokenModel.fromServerData));
}

export async function getUserPersonalAccessTokens(userId: string) {
  const { data } = await apiReq("GET", `/v1/users/${userId}/personalAccessTokens`);

  return List<PersonalAccessTokenModel>(data.map(PersonalAccessTokenModel.fromServerData));
}

export const createPersonalAccessToken = async (token: TCreatePersonalAccessToken) => {
  const { data: newToken } = await apiReq("POST", "/v1/userAccessTokens", token);

  return PersonalAccessTokenModel.fromServerData(newToken);
};

export const updatePersonalAccessToken = async (id: string, name: string) => {
  const { data: updatedToken } = await apiReq("PUT", `/v1/userAccessTokens/${id}`, { name });

  return PersonalAccessTokenModel.fromServerData(updatedToken);
};

export const deletePersonalAccessToken = async (id: string) => {
  return apiReq("DELETE", `/v1/userAccessTokens/${id}`);
};

export async function getUsersPersonalAccessTokens(): Promise<List<UserPersonalAccessTokenModel>> {
  const { data } = await apiReq("GET", "/v1/userAccessTokens/usersTokens/all");

  return List(data.map((token: unknown) => UserPersonalAccessTokenModel.fromServerData(token)));
}
